
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$label.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$label.js';
export default __default__;
